<template>
    <Card class="mb-4">
        <CardContent class="p-4">
            <!-- Header Row -->
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-4">
                    <img :src="logo" :alt="`${title} logo`" class="w-10 h-10" />
                    <div>
                        <div class="flex items-center gap-2">
                            <span class="text-lg font-medium">{{ title }}</span>
                            <CheckCircle v-if="isConnected" class="h-5 w-5 text-accent-foreground" />
                        </div>
                        <div class="flex items-center gap-1 text-sm text-muted-foreground">
                            <ExternalLink class="h-4 w-4" />
                            <span>Redirect Integration</span>
                        </div>
                    </div>
                </div>
                <!-- Action Button in header row -->
                <div class="flex items-center gap-2">
                    <LoaderCircle v-if="loading || isPolling" class="h-4 w-4 animate-spin" />
                    <Button
                        @click="toggleConnection"
                        :disabled="loading || isPolling"
                        :variant="isConnected ? 'outline' : 'default'"
                        :class="isConnected ? 'border-destructive text-destructive hover:bg-destructive hover:text-destructive-foreground' : ''">
                        {{ isConnected ? 'Disconnect' : 'Connect' }}
                    </Button>
                </div>
            </div>
        </CardContent>
    </Card>
</template>

<script setup>
import { ref } from 'vue';
import { CheckCircle, ExternalLink, LoaderCircle } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import * as notificationsApi from '../../../api/notifications.api';

const props = defineProps({
    title: { type: String, required: true },
    logo: { type: String, required: true },
    isConnected: { type: Boolean, default: false },
    url: { type: String, default: null },
    subscriberId: { type: String, default: null },
    providerId: { type: String, default: null },
    isPolling: { type: Boolean, default: false }
});

const emit = defineEmits(['update:subscriber', 'update:isConnected']);

const loading = ref(false);

const toggleConnection = async () => {
    loading.value = true;
    try {
        const connected = !props.isConnected;
        if (connected && props.url) {
            window.open(props.url, '_blank');
            emit('update:subscriber', null);
        } else if (!connected && props.url) {
            await notificationsApi.deleteSubscriberCredentials(props.subscriberId, props.providerId);
            emit('update:isConnected', false);
        }
    } catch (error) {
        console.error('Error toggling redirect connection:', error);
    } finally {
        loading.value = false;
    }
};
</script>

